// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountModel {
    static getAttributeTypeMap() {
        return AccountModel.attributeTypeMap;
    }
}
AccountModel.discriminator = undefined;
AccountModel.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "displayId",
        "baseName": "displayId",
        "type": "string"
    },
    {
        "name": "accountType",
        "baseName": "accountType",
        "type": "AccountType"
    },
    {
        "name": "accountStatus",
        "baseName": "accountStatus",
        "type": "AccountStatus"
    },
    {
        "name": "partyId",
        "baseName": "partyId",
        "type": "number"
    },
    {
        "name": "securePartyId",
        "baseName": "securePartyId",
        "type": "string"
    },
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "assignedUser",
        "baseName": "assignedUser",
        "type": "number"
    },
    {
        "name": "lastModifiedBy",
        "baseName": "lastModifiedBy",
        "type": "number"
    },
    {
        "name": "lastModifiedTime",
        "baseName": "lastModifiedTime",
        "type": "Date"
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": "Array<AccountPayorRelationModel>"
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": "Array<AccountRelationModel>"
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": "Array<AccountRelationModel>"
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": "Array<AccountRelationModel>"
    },
    {
        "name": "accountAddresses",
        "baseName": "accountAddresses",
        "type": "Array<AccountAddressModel>"
    },
    {
        "name": "accountPhoneNumbers",
        "baseName": "accountPhoneNumbers",
        "type": "Array<AccountPhoneModel>"
    },
    {
        "name": "documents",
        "baseName": "documents",
        "type": "Array<AccountDocumentRelationshipModel>"
    },
    {
        "name": "notes",
        "baseName": "notes",
        "type": "Array<number>"
    },
    {
        "name": "tasks",
        "baseName": "tasks",
        "type": "Array<number>"
    },
    {
        "name": "accountSessions",
        "baseName": "accountSessions",
        "type": "Array<AccountSessionModel>"
    },
    {
        "name": "voicemailOptInStatus",
        "baseName": "voicemailOptInStatus",
        "type": "Array<AccountVoicemailOptInModel>"
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": "Array<AccountExternalIdModel>"
    },
    {
        "name": "assignmentOfBenefitFlag",
        "baseName": "assignmentOfBenefitFlag",
        "type": "boolean"
    },
    {
        "name": "accountContacts",
        "baseName": "accountContacts",
        "type": "Array<AccountContactModel>"
    },
    {
        "name": "isIneligibleForMailInClaims",
        "baseName": "isIneligibleForMailInClaims",
        "type": "boolean"
    },
    {
        "name": "linkedPayors",
        "baseName": "linkedPayors",
        "type": "Array<AccountLinkedPayorModel>"
    },
    {
        "name": "allowAutoReenroll",
        "baseName": "allowAutoReenroll",
        "type": "boolean"
    },
    {
        "name": "contactPreferences",
        "baseName": "contactPreferences",
        "type": "Array<AccountContactPreferenceModel>"
    },
    {
        "name": "attestations",
        "baseName": "attestations",
        "type": "Array<AccountAttestationAttributeModel>"
    },
    {
        "name": "optionalServices",
        "baseName": "optionalServices",
        "type": "Array<AccountOptionalServiceModel>"
    },
    {
        "name": "accountServices",
        "baseName": "accountServices",
        "type": "Array<AccountServiceModel>"
    }
];
//# sourceMappingURL=accountModel.js.map